<template>
  <div :class="`chip-select ${fullWidth ? 'chip-select--full-width' : ''}`">
    <v-chip
      @click="onClick"
      :disabled="readonly"
      :style="`background-color: ${bgColor};`"
      :class="`${fullWidth ? 'chip-select--full-width' : ''}`"
      >{{ selectedName }}
      <v-icon size="12" class="ml-2" v-if="!readonly"
        >bhi-pencil</v-icon
      ></v-chip
    >
    <div
      class="chip-select-menu"
      :id="`chip-select-menu-${id}`"
      v-if="!readonly"
    ></div>
    <v-select
      v-if="!readonly"
      :attach="`#chip-select-menu-${id}`"
      class="d-none"
      :value="value"
      :items="items"
      :menu-props="{ value: selectOpened }"
      solo
      @blur="toggleSelect"
      @change="change"
    ></v-select>
  </div>
</template>
<script>
export default {
  name: 'ChipSelect',
  props: {
    bgColor: {
      type: String,
      default: 'var(--bh-gray--6)',
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number],
    },
    overrideClick: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    id: null,
    selectOpened: false,
  }),
  mounted() {
    // Get unique id of component
    this.id = this._uid
  },
  computed: {
    selectedName() {
      const currentSelection = this.items.find(el => el.value === this.value)
      return currentSelection?.text || 'None'
    },
  },
  methods: {
    toggleSelect() {
      this.selectOpened = !this.selectOpened
    },
    onClick() {
      if (this.overrideClick) {
        this.$emit('click')
      } else {
        this.toggleSelect()
      }
    },
    change($event) {
      this.$emit('change', $event)
      this.toggleSelect()
    },
  },
}
</script>
<style lang="scss">
.chip-select {
  &--full-width {
    width: 100%;
  }
  &-menu {
    position: relative;

    .v-menu__content {
      max-width: none;
    }
  }
}
</style>
